import { connect } from 'react-redux';
import Loading     from '../components/Loading';

const mapStateToProps = state => ({
  loading: state.get('loading'),
});

export default connect(mapStateToProps)(Loading);
